var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBellOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1314_24380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86659 14C6.97817 14.203 7.14222 14.3722 7.34158 14.4901C7.54094 14.608 7.76831 14.6702 7.99992 14.6702C8.23153 14.6702 8.4589 14.608 8.65826 14.4901C8.85762 14.3722 9.02166 14.203 9.13325 14M2.66659 1.33333C1.86659 2.46666 1.33325 3.8 1.33325 5.33333M14.6666 5.33333C14.6666 3.8 14.1333 2.46666 13.3333 1.33333M3.99992 5.33333C3.99992 4.27246 4.42135 3.25505 5.17149 2.5049C5.92164 1.75476 6.93905 1.33333 7.99992 1.33333C9.06078 1.33333 10.0782 1.75476 10.8283 2.5049C11.5785 3.25505 11.9999 4.27246 11.9999 5.33333C11.9999 10 13.9999 11.3333 13.9999 11.3333H1.99992C1.99992 11.3333 3.99992 10 3.99992 5.33333Z",
    stroke: "#F57C00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1314_24380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellOn);
export default __webpack_public_path__ + "static/media/icon_bell_on.0df977c12a9176f5d5cbfe610b05b466.svg";
export { ForwardRef as ReactComponent };